<!-- Identificação do ambiente (ex.: DEV). Não aparece em produção. -->
<div *ngIf="environmentTag"
    class="fixed top-0 left-1/2 -translate-x-1/2 z-[60] px-4 py-0.5 text-xs font-bold tracking-widest text-white bg-amber-500 rounded-b shadow pointer-events-none">
    {{ environmentTag }}
</div>

<div class="flex h-screen bg-gray-100">
    <!-- Sidebar -->
    <div *ngIf="userIsLogged && !isLandingPage"
        class="fixed inset-y-0 left-0 w-64 bg-gray-800 text-gray-200 shadow-lg flex flex-col transition-transform duration-300 ease-in-out z-50"
        [ngClass]="{'-translate-x-full': !menuOpen, 'translate-x-0': menuOpen}">
        <div class="p-4 text-xl font-semibold text-white">
            FLOWTIFY
        </div>
        <nav class="flex-1 px-4 py-6 space-y-4">
            <!-- Quando bloqueado por fatura vencida, mostrar apenas Faturas e Sair -->
            <ng-container *ngIf="!isBlockedByOverdue">
                <ng-container *appHasPermission="'dashboards.view'">
                    <a [routerLink]="['/dashboard']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.dashboard' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-chart-line mr-3"></i>
                        {{ 'nav.dashboard' | transloco }}
                    </a>
                </ng-container>

                <ng-container *appHasPermission="'labels.view'">
                    <a *ngIf="!isMobileDevice" [routerLink]="['/label-print']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.labels' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-print mr-3"></i>
                        <span>{{ 'nav.labels' | transloco }}</span>
                    </a>
                </ng-container>

                <ng-container *appHasPermission="'orders.view'">
                    <a [routerLink]="['/seller-orders']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.orders' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-box mr-3"></i>
                        <span>{{ 'nav.orders' | transloco }}</span>
                    </a>
                </ng-container>

                <a *ngIf="isMobileDevice" [routerLink]="['/qr-scanner']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.qrScanner' | transloco"
                    class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                    <i class="fas fa-qrcode mr-3"></i>
                    <span>{{ 'nav.qrScanner' | transloco }}</span>
                </a>
            </ng-container>

            <!-- Faturas: sempre visível quando bloqueado; senão exige permissão -->
            <a *ngIf="isBlockedByOverdue" [routerLink]="['/invoices']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.invoicesRegularize' | transloco"
                class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                <i class="fas fa-file-invoice mr-3"></i>
                <span>{{ 'nav.invoices' | transloco }}</span>
            </a>
            <ng-container *ngIf="!isBlockedByOverdue">
                <ng-container *appHasPermission="'invoices.view'">
                    <a *ngIf="!isMobileDevice" [routerLink]="['/invoices']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.invoices' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-file-invoice mr-3"></i>
                        <span>{{ 'nav.invoices' | transloco }}</span>
                    </a>
                </ng-container>
                <ng-container *appHasPermission="'invoices.view'">
                    <a *ngIf="isMobileDevice" [routerLink]="['/invoices']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.invoices' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-file-invoice mr-3"></i>
                        <span>{{ 'nav.invoices' | transloco }}</span>
                    </a>
                </ng-container>

                <a *ngIf="false" [routerLink]="['/checklist']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.production' | transloco"
                    class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                    <i class="fa-solid fa-industry mr-3"></i>
                    {{ 'nav.production' | transloco }}
                </a>

                <a *ngIf="false" [routerLink]="['/product-group']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.productGroup' | transloco"
                    class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                    <i class="fas fa-boxes mr-3"></i>
                    {{ 'nav.productGroup' | transloco }}
                </a>

                <ng-container *appHasPermission="'users.view'">
                    <a *ngIf="!isMobileDevice" [routerLink]="['/users']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.users' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-users mr-3"></i>
                        {{ 'nav.users' | transloco }}
                    </a>
                </ng-container>

                <ng-container *appHasPermission="'settings.view'">
                    <a *ngIf="!isMobileDevice" [routerLink]="['/settings']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.settings' | transloco"
                        class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                        <i class="fas fa-cog mr-3"></i>
                        {{ 'nav.settings' | transloco }}
                    </a>
                </ng-container>

                <a *ngIf="!isMobileDevice" [routerLink]="['/integrations']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.integrations' | transloco"
                    class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                    <i class="fas fa-plug mr-3"></i>
                    {{ 'nav.integrations' | transloco }}
                </a>

                <!-- Só em desenvolvimento: ferramenta para simular o Mercado Livre -->
                <a *ngIf="mlStubEnabled" [routerLink]="['/ml-stub']" (click)="closeMenuIfMobile()" routerLinkActive="active" [title]="'nav.tip.mlStub' | transloco"
                    class="flex items-center py-2 px-4 text-amber-300 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                    <i class="fas fa-flask mr-3"></i>
                    {{ 'nav.mlStub' | transloco }}
                </a>
            </ng-container>

            <a href="#" (click)="closeMenuIfMobile(); logout()" [attr.tooltip]="'nav.tip.logout' | transloco"
                class="flex items-center py-2 px-4 text-gray-100 hover:bg-gray-700 rounded transition duration-200 ease-in-out">
                <i class="fas fa-sign-out-alt mr-3"></i>
                {{ 'nav.logout' | transloco }}
            </a>
        </nav>

        <!-- Rodapé do menu: seletor de idioma (bandeiras) -->
        <div class="px-4 py-4 border-t border-gray-700 flex justify-center">
            <app-language-switcher variant="flags"></app-language-switcher>
        </div>
    </div>

    <!-- Main Content Area -->
    <div class="flex flex-col flex-1 transition-all duration-300 ease-in-out"
        [ngClass]="{'ml-0': !menuOpen || isLandingPage, 'ml-0 md:ml-64': menuOpen && userIsLogged && !isLandingPage}">
        <!-- Header -->
        <header *ngIf="userIsLogged && !isLandingPage" class="bg-white shadow-md p-3 sm:p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
            <div class="flex items-center w-full sm:w-auto justify-between sm:justify-start">
                <button (click)="toggleMenu()" class="text-subtle hover:text-content focus:outline-none flex-shrink-0">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16">
                        </path>
                    </svg>
                </button>

                <!-- Breadcrumb -->
                <nav class="hidden md:flex items-center gap-2 text-sm flex-shrink-0 ml-3" aria-label="Breadcrumb">
                    <a [routerLink]="['/home']" class="flex items-center gap-1.5 text-subtle hover:text-content transition-colors">
                        <i class="fas fa-home text-xs" aria-hidden="true"></i>
                        <span>{{ 'breadcrumb.home' | transloco }}</span>
                    </a>
                    <span class="text-subtle" aria-hidden="true">/</span>
                    <span class="font-medium text-brand">{{ breadcrumbKey | transloco }}</span>
                </nav>

                <!-- Banner de bloqueio por fatura vencida há mais de 7 dias -->
                <div *ngIf="isBlockedByOverdue && userIsLogged" (click)="navigateToInvoices()"
                     class="flex items-center space-x-2 bg-red-600 text-white px-3 sm:px-4 py-2 cursor-pointer hover:bg-red-700 transition-colors ml-2 sm:ml-4 rounded border border-red-700">
                    <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                    </svg>
                    <div class="flex flex-col">
                        <span class="text-sm font-bold">{{ 'header.blockedAccess' | transloco }}</span>
                        <span class="text-xs font-medium opacity-95">{{ 'header.blockedMessage' | transloco }}</span>
                    </div>
                </div>
                <!-- Notificação de Faturas Vencidas - Centralizada -->
                <!-- Prioridade 1: Faturas Vencidas (Vermelho) - ocultar quando bloqueado (banner exibido) -->
                <div *ngIf="showOverdueNotification && userIsLogged && !isOnInvoicesPage && !isBlockedByOverdue" 
                     (click)="navigateToInvoices()"
                     class="flex items-center space-x-2 bg-red-50 border border-red-400 px-3 sm:px-4 py-2 cursor-pointer hover:bg-red-100 transition-colors animate-pulse ml-2 sm:ml-4">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                    </svg>
                    <div class="flex flex-col">
                        <span class="text-xs sm:text-sm font-semibold text-red-800">
                            <span *ngIf="overdueInvoicesTotal > 0">{{ overdueInvoicesTotal }} </span>
                            {{ (overdueInvoicesTotal > 1 ? 'header.invoiceOverdueMany' : 'header.invoiceOverdueOne') | transloco }}
                        </span>
                        <span class="text-xs text-red-700 font-medium hidden sm:block">{{ 'header.riskInterruption' | transloco }}</span>
                    </div>
                </div>
                
                <!-- Prioridade 2: Fatura Vencendo Hoje (Amarelo/Warning) -->
                <div *ngIf="showDueTodayNotification && userIsLogged && !isOnInvoicesPage && !isBlockedByOverdue" 
                     (click)="navigateToInvoices()"
                     class="flex items-center space-x-2 bg-yellow-50 border border-yellow-400 px-3 sm:px-4 py-2 cursor-pointer hover:bg-yellow-100 transition-colors ml-2 sm:ml-4">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                    </svg>
                    <div class="flex flex-col">
                        <span class="text-xs sm:text-sm font-semibold text-yellow-800">
                            <span *ngIf="dueTodayCount > 0">{{ dueTodayCount }} </span>
                            {{ (dueTodayCount > 1 ? 'header.invoiceDueTodayMany' : 'header.invoiceDueTodayOne') | transloco }}
                        </span>
                        <span class="text-xs text-yellow-700 font-medium hidden sm:block">{{ 'header.dueTodayWarning' | transloco }}</span>
                    </div>
                </div>
                
                <!-- Prioridade 3: Faturas Próximas (Azul/Info) -->
                <div *ngIf="showUpcomingNotification && userIsLogged && !isOnInvoicesPage && !isBlockedByOverdue" 
                     (click)="navigateToInvoices()"
                     class="flex items-center space-x-2 bg-blue-50 border border-blue-400 px-3 sm:px-4 py-2 cursor-pointer hover:bg-blue-100 transition-colors ml-2 sm:ml-4">
                    <svg class="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                    </svg>
                    <div class="flex flex-col">
                        <span class="text-xs sm:text-sm font-semibold text-blue-800">
                            <span *ngIf="upcomingDueCount > 0">{{ upcomingDueCount }} </span>
                            {{ (upcomingDueCount > 1 ? 'header.invoiceUpcomingMany' : 'header.invoiceUpcomingOne') | transloco }}
                        </span>
                        <span class="text-xs text-blue-700 font-medium hidden sm:block">{{ 'header.upcomingInfo' | transloco }}</span>
                    </div>
                </div>
            </div>
            <div *ngIf="(!showOverdueNotification && !showDueTodayNotification && !showUpcomingNotification) || !userIsLogged" class="text-xl font-semibold text-gray-700 hidden sm:block"></div>
            <div class="flex items-center space-x-3 sm:space-x-4 w-full sm:w-auto">
                <ng-select
                    [(ngModel)]="selectedAccount"
                    (change)="onAccountChange($event)"
                    [items]="accounts"
                    bindLabel="nickname"
                    [clearable]="false"
                    [searchable]="true"
                    [placeholder]="'header.selectAccount' | transloco"
                    class="w-full flex-shrink-0 header-select">
                    <ng-template ng-label-tmp let-item="item">{{ item.nickname | titlecase }}</ng-template>
                    <ng-template ng-option-tmp let-item="item">{{ item.nickname | titlecase }}</ng-template>
                </ng-select>
                <!-- Status dos serviços (pill + popover) -->
                <app-health-indicator class="flex-shrink-0"></app-health-indicator>
                <!-- Tema: claro / escuro / sistema (entre o status e o avatar) -->
                <app-theme-switcher class="flex-shrink-0"></app-theme-switcher>

                <!-- Avatar + menu do usuário -->
                <div class="relative flex-shrink-0">
                    <button type="button" (click)="toggleUserMenu()"
                        class="user-trigger"
                        [attr.aria-expanded]="userMenuOpen" aria-haspopup="menu"
                        [attr.aria-label]="userDisplayName">
                        <span class="avatar">{{ userInitials }}</span>
                        <i class="fas fa-chevron-down text-xs text-subtle transition-transform"
                           [class.rotate-180]="userMenuOpen" aria-hidden="true"></i>
                    </button>

                    <div *ngIf="userMenuOpen" class="fixed inset-0 z-40" (click)="closeUserMenu()"></div>

                    <div *ngIf="userMenuOpen" class="user-menu" role="menu">
                        <div class="user-menu__head">
                            <span class="avatar avatar--lg">{{ userInitials }}</span>
                            <div class="min-w-0">
                                <p class="user-menu__name">{{ userDisplayName }}</p>
                                <p class="user-menu__mail" *ngIf="user?.internalEmail">{{ user.internalEmail }}</p>
                            </div>
                        </div>
                        <a [routerLink]="['/settings']" (click)="closeUserMenu()" class="user-menu__item" role="menuitem">
                            <i class="fas fa-cog" aria-hidden="true"></i>{{ 'nav.settings' | transloco }}
                        </a>
                        <button type="button" (click)="closeUserMenu(); logout()" class="user-menu__item user-menu__item--danger" role="menuitem">
                            <i class="fas fa-sign-out-alt" aria-hidden="true"></i>{{ 'nav.logout' | transloco }}
                        </button>
                    </div>
                </div>
            </div>
        </header>

        <!-- Conteúdo da Página -->
        <main [ngClass]="{'flex-1 p-3 sm:p-6 bg-gray-50': !isLandingPage, 'flex-1': isLandingPage}">
            <router-outlet />
        </main>
        <ngx-spinner [size]="'medium'" type="ball-grid-pulse"></ngx-spinner>

    </div>
</div>